export const CLEAR_ERROR = "CLEAR_ERROR"
export const ORDER_REQUEST = "ORDER_REQUEST";
export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const ORDER_FAIL = "ORDER_FAIL";
export const SAVE_DEVICE_INFO = "SAVE_DEVICE_INFO"
export const Empty_DEVICE_INFO = "Empty_DEVICE_INFO"
export const CLEAR_ORDER = "CLEAR_ORDER"